<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: 1500px;").mb-5
        thead
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="3")
              div {{ $t('ui.full_time') }}
            th(colspan="3")
              div {{ $t('ui.first_half') }}
            th(colspan="3")
              div {{ $t('ui.double_chance') }}
          tr
            th(style="width: 100px;")
              div 1
            th(style="width: 100px;")
              div X
            th(style="width: 100px;")
              div 2
            th(style="width: 100px;")
              div 1
            th(style="width: 100px;")
              div X
            th(style="width: 100px;")
              div 2
            th(style="width: 100px;")
              div 1X
            th(style="width: 100px;")
              div 12
            th(style="width: 100px;")
              div X2
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-danger {{ item.ta }}
              div.text-danger {{ item.ln }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.f1_blink }") {{ item.f1 }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.fx_blink }") {{ item.fx }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.f2_blink }") {{ item.f2 }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.h1_blink }") {{ item.h1 }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.hx_blink }") {{ item.hx }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.h2_blink }") {{ item.h2 }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.f1x_blink }") {{ item.f1x }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.f12_blink }") {{ item.f12 }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.fx2_blink }") {{ item.fx2 }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>